<script>
    import { Link } from "svelte-navigator";
    import PrivateLink from "../elements/PrivateLink.svelte"
</script>

<nav>
    <Link to="/">Home</Link>
    <Link to="contacts">Contacts</Link>
    <PrivateLink to="profile">Profile</PrivateLink>
</nav>